import { ChangeDetectorRef, Component, ContentChild, Injector, Input, OnInit, TemplateRef } from '@angular/core';
import { BaseComponentWithDialog } from "../base-component-with-dialog";
import { TranslateService } from "@ngx-translate/core";
import { ObjectsManagementDialogComponent } from "../../objects-management-dialog/objects-management-dialog.component";
import { IManagableObject } from "../../IManagableObject";

@Component({
  selector: 'app-base-group-mgmt-component',
  templateUrl: './base-group-mgmt-component.component.html',
  styleUrls: ['./base-group-mgmt-component.component.css'],
  standalone: false
})
export class BaseGroupMgmtComponentComponent extends BaseComponentWithDialog implements OnInit {

  //selected groups (current groups)
  @Input()
  Objects: Array<IManagableObject | number> = [];

  //all groups
  @Input('groups')
  set onGroupsSet(val) {
    this.cdr.detectChanges();
    this.groups = val;
    this.filtered = val;
  }
  public groups: IManagableObject[] = [];

  @Input()
  public groupsUsedForObjectsSelection: IManagableObject[] = [];

  //available groups
  @Input()
  public filtered: IManagableObject[] = [];

  @Input()
  Title: string;

  @Input()
  readonly: boolean = false;
  private translate: TranslateService;

  @ContentChild(TemplateRef, /* TODO: add static flag */ {}) templateRef: TemplateRef<any>;

  constructor(protected injector: Injector,
    private cdr: ChangeDetectorRef) {
    super(injector);
    this.translate = injector.get(TranslateService)
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.Title = this.translate.instant(this.Title);
  }

  public onRemoveAllClick() {
    if (confirm(this.translate.instant("Clear") + "?"))
      this.Objects.splice(0, this.Objects.length);
  }

  public onAddGroupClick() {
    this.prepareModal(ObjectsManagementDialogComponent);

    this.componentRef.instance.groups = this.groupsUsedForObjectsSelection;
    this.componentRef.instance.title = this.Title;
    //не входят в текущую группу
    this.componentRef.instance.objects = this.filtered.filter(d => (this.Objects && !this.Objects.map(x => this.getObjectId(x)).includes(d.Id)))
      .map(obj => {
        obj.IsChecked = false;
        return obj;
      });
    this.componentRef.instance.onSubmit.subscribe(() => {
      // this.model.Groups = [];
      this.componentRef.instance.objects.forEach((group: IManagableObject) => {
        if (group && group.IsChecked) {
          this.Objects.push(this.toStoredObject(group));
        }
        if (group && !group.IsChecked) {
          let idx = this.Objects.map(x => this.getObjectId(x)).indexOf(group.Id);
          if (idx >= 0)
            this.Objects.splice(idx, 1);
        }
        this.filtered = this.filtered.filter(x => !this.Objects.map(y => this.getObjectId(y)).includes(x.Id))
      });
      this.componentRef.instance.close();
    });
    this.componentRef.instance.open();
  }
  public removeFromGroup(group: IManagableObject) {
    let idx = this.Objects.map(x => this.getObjectId(x)).indexOf(group.Id);
    if (idx >= 0) {
      this.Objects.splice(idx, 1);
      this.filtered.push(group);
    }
  }
  public getItem(object: IManagableObject | number): any {
    const objectId = this.getObjectId(object);
    let grp = this.groups.find(p => p.Id == objectId);
    if (grp)
      return grp;
    return new class implements IManagableObject {
      Id: number;
      IsChecked: boolean;
      Name: string;
    };
  }

  private getObjectId(object: IManagableObject | number): number {
    return typeof object === 'number' ? object : object?.Id;
  }

  private toStoredObject(group: IManagableObject): IManagableObject | number {
    return this.shouldStoreIds() ? group.Id : group;
  }

  private shouldStoreIds(): boolean {
    return this.Objects.length === 0 || typeof this.Objects[0] === 'number';
  }
}
